import { styled } from '@material-ui/core'
import { Typography, Button as ButtonBase } from '@material-ui/core'
import { Icon as BaseIcon } from '@iconify/react'
import { KeyboardDatePicker } from '@material-ui/pickers'

const INPUT_WIDTH = 120
const INPUT_HEIGHT = 36
const BUTTON_WIDTH = 50

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: theme.spacing(1.2, 2, 0),
}))

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}))

export const Main = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingRight: theme.spacing(2),
  padding: theme.spacing(1, 0, 0.5),
}))

export const Label = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(1.6),
  marginTop: INPUT_HEIGHT / 2,
  transform: 'translateY(-50%)',
}))

export const InputWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  '&:first-child': {
    marginRight: theme.spacing(2.5),
  },
}))

export const DatePicker = styled(KeyboardDatePicker)(({ theme }) => ({
  width: INPUT_WIDTH,
  '& input': {
    height: INPUT_HEIGHT,
    boxSizing: 'border-box',
    padding: theme.spacing(1, 0),
  },
  '& button': {
    padding: 0,
  },
}))

export const Button = styled(ButtonBase)({
  padding: 0,
  fontSize: 10,
  lineHeight: '11px',
  width: BUTTON_WIDTH,
  textTransform: 'uppercase',
})

export const Icon = styled(BaseIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  transition: 'all .3s',
}))
